import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ReactFlagsSelect from 'react-country-flag';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import ListSubheader from '@mui/material/ListSubheader';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';

export function CustomFieldTemplate(props) {
  const { id, classNames, label, help, required, description, errors, children } = props;
  return (
    <div className={classNames + ' customWrapper'}>
      <label htmlFor={id} className={classNames + ' customLabel'}>{label}{required ? "*" : null}</label>
      {children}
      {description}
      {errors}
      {help}
    </div>
  );
}

export const autocomplete = (props) => {
  const { onChange } = props;
  console.log("autocomplete props value", props.label + " ------- " + props.value);

  console.log("autocomplete options", props.options && props.options.enumOptions);
  const cars = props.options && props.options.enumOptions ? props.options.enumOptions : [];

  const handleAutocompleteChange = (event, value) => {
    console.log("autocomplete change", value);
    onChange(value);
  };

  return (
    <FormControl variant="filled">
      <Autocomplete
        options={cars}
        getOptionLabel={(option) => option.label}
        value={cars.find(car => car.value === props.value) || null}
        onChange={handleAutocompleteChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant="filled"
            required={props.required}
          />
        )}
      />
    </FormControl>
  );
}

export const select = (props) => {
  const { onChange } = props;
  console.log("Select props value", props.label + " ------- " + props.value);

  let selectValue = props.value !== undefined ? props.value : '';

  return (
    <FormControl variant="filled">
      <InputLabel id={props.id}>{props.label}</InputLabel>
      <Select
        labelId={props.id}
        id={props.id}
        value={selectValue}
        required={props.required}
        onChange={(event) => props.onChange(event.target.value)}
      >
        {props.options && props.options.enumOptions && props.options.enumOptions.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export const text = (props) => {
  const { onChange } = props;
  console.log("text props value", props.label + " ------- " + props.value);

  return (
    <FormControl variant="filled">
      <TextField
        labelId={props.id}
        id={props.id}
        value={props.value}
        required={props.required}
        onChange={(event) => props.onChange(event.target.value)}
        label={props.label}
        variant="filled"
        
      />
    </FormControl>
  );
}

export const SelectGroup = (props) => {
  const { onChange } = props;
  console.log("Select props value", props.label + " ------- " + props.value);

  let selectValue = props.value !== undefined ? props.value : '';

  return (
    <FormControl variant="filled">
      <InputLabel id={props.id}>{props.label}</InputLabel>
      <Select
        labelId={props.id}
        id={props.id}
        value={selectValue}
        required={props.required}
        onChange={(event) => props.onChange(event.target.value)}
      >
        <ListSubheader>Category 1</ListSubheader>
        {props.options && props.options.enumOptions && props.options.enumOptions.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export const country = (props) => {
  const { onChange } = props;

  const onSelectFlag = (countryCode) => {
    console.log(countryCode);
    onChange(countryCode);
  }

  return (
    <ReactFlagsSelect
      labelId={props.id}
      id={props.id}
      value={props.value}
      required={props.required}
      defaultCountry="IN"
      searchable={true}
      onSelect={onSelectFlag}
    />
  );
}

export const date = (props) => {
  const { onChange } = props;
  let selectedDateNew = props.value !== undefined ? moment(props.value).toDate() : null;
  const handleDateChange = (value) => {
    console.log(new Date(value))
    const dateChangeFormat = moment(value).format('MM-DD-YYYY').toString();
    onChange(dateChangeFormat)
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label={props.label}
        value={selectedDateNew}
        onChange={handleDateChange}
        format="MM-DD-YYYY"
        slotProps={{
          textField: {
            variant: "filled",
            fullWidth: true,
            margin: "normal"
          }
        }}
      />
    </LocalizationProvider>
  );
}

export const widgets = {
  select: select,
  text: text,
  date: date,
  country: country,
  autocomplete: autocomplete

}


export const customStyles = {
  content: {
    left: '50%',
    bottom: 'auto',
    transform: 'translate(-50%, 0%)',
    width: '1000px',
    zIndex: '10000',
    yOverflow: 'scroll',
    xOverflow: 'hidden'
  }
};

export const customStylesauto = {
  content: {
    left: '50%',
    bottom: 'auto',
    transform: 'translate(-50%, 0%)',
    width: '800px',
    zIndex: '10000',
  }
};

export const customStylesauto1 = {
  content: {
    left: '50%',
    bottom: 'auto',
    transform: 'translate(-50%, 0%)',
    width: '500px',
    zIndex: '10000',
  }
};

export const customStylesSmall = {
  content: {
    left: '50%',
    bottom: 'auto',
    transform: 'translate(-50%, 0%)',
    width: '600px',
    zIndex: '10000',
    height: 'auto',
    yOverflow: 'scroll',
    xOverflow: 'hidden'
  }
};

export function ObjectFieldTemplate(props) {
  return (
    <div className="row" id="initialsetupform">
      {props.title ? (
        <div className="col-md-12 col-sm-12">
          <h5 className="MuiTypography-root MuiTypography-h5">{props.title}</h5>
        </div>
      ) : null}

      {props.description ? (
        <div className="col-md-12 col-sm-12 text-left">
          <p>{props.description}</p>
        </div>
      ) : null}

      {props.properties.map((element) => (
        <div className={element.name + " col-md-3 col-sm-12 mb-3 " + element.id} id={element.id} key={element.id}>
          <React.Fragment>
            {element.content}
          </React.Fragment>
        </div>
      ))}
    </div>
  );
}

export const theme = createTheme({
  palette: {
    primary: {
      main: '#048c88',
      light: '#064e4a',
      dark: '#064e4a'
    },
    secondary: {
      main: '#49ae46',
      light: '#d5f2f0',
      dark: '#2e9a2b'
    }
  },
  props: {
    MuiButton: {
      size: 'medium',
    },
    MuiFilledInput: {},
    MuiFormControl: {},
    MuiFormHelperText: {},
    MuiIconButton: {
      size: 'medium',
    },
    MuiInputBase: {},
    MuiInputLabel: {},
    MuiListItem: {
      dense: true,
    },
    MuiOutlinedInput: {},
    MuiFab: {
      size: 'medium',
    },
    MuiTable: {
      size: 'medium',
    },
    MuiTextField: {
      variant: "filled",
      size: "medium",
    },
    MuiToolbar: {
      variant: 'dense',
    },
  },
  overrides: {},
});
